var _style, _path, _defs, _mask, _path2, _defs2, _mask2, _path3, _defs3, _mask3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJobLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 111.767 18.035",
    enableBackground: "new 0 0 111.767 18.035",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#353535}.st1{filter:url(#Adobe_OpacityMaskFilter)}.st2,.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#fff}.st3{mask:url(#bj6fr9d4sb_5_);fill:#ffe22e}.st4{filter:url(#Adobe_OpacityMaskFilter_1_)}.st5{mask:url(#bj6fr9d4sb_6_);fill-rule:evenodd;clip-rule:evenodd;fill:#fefefd}.st6{filter:url(#Adobe_OpacityMaskFilter_2_)}.st7{mask:url(#bj6fr9d4sb_7_);fill-rule:evenodd;clip-rule:evenodd;fill:#353535}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59.761 17.702v-.001zM59.226 5.076c0-1.632-.521-2.865-1.55-3.662C56.753.7 55.413.338 53.69.338h-4.853v17.364h1.755v-7.675h2.852l4.287 7.674h2.029l-4.412-7.834c2.458-.511 3.878-2.222 3.878-4.791zm-5.824 3.317h-2.81v-6.42h2.81c2.829 0 4.036.928 4.036 3.103 0 1.111-.34 1.951-1.01 2.495-.67.545-1.688.822-3.026.822zM63.226 9.328h6.35V7.674h-6.35v-5.68h7.562V.339H61.47v17.362h9.558v-1.653h-7.802zM86.053 17.702v-.001zM78.681.338l-5.8 17.364h1.802l1.87-5.737h5.794l1.845 5.736h1.861L80.254.338h-1.573zm3.143 10h-4.741l.88-2.701a131.731 131.731 0 0 0 1.495-4.835c.49 1.712.988 3.267 1.498 4.834l.868 2.702zM91.842.338h-3.988v17.364h4.012c4.771 0 7.508-3.185 7.508-8.735 0-2.667-.621-4.771-1.845-6.255C96.231 1.137 94.317.338 91.842.338zm4.32 13.775c-.989 1.293-2.48 1.949-4.43 1.949h-2.123V1.977h2.123c1.957 0 3.449.64 4.433 1.9.93 1.189 1.4 2.901 1.4 5.09 0 2.199-.472 3.93-1.403 5.146zM10.062 11.601c0 2.319-.72 3.039-2.053 3.039-.842 0-1.686-.544-2.296-1.74l-2.534 1.989c1.143 2.106 2.801 3.146 5.321 3.146 3.644 0 5.29-2.76 5.29-6.107V.321h-3.728v11.28zM109.919.339l-2.496 5.417-.004.01c-.405.956-.857 1.866-1.337 2.829l-.133.267a108.04 108.04 0 0 1-1.056-2.281l-.375-.824-2.496-5.419h-1.902l4.946 10.336v7.027h1.756v-7.026L111.767.339h-1.848zM42.956 8.497V8.39c1.345-.535 2.172-2.195 2.172-3.755 0-3.323-2.657-4.315-6.08-4.315h-5.643v17.395h6.113c3.586 0 6.423-1.586 6.423-5.124 0-2.324-1.301-3.633-2.985-4.094zm-5.825-5.142h1.77c1.738 0 2.583.521 2.583 1.861 0 1.265-.801 2.071-2.61 2.071h-1.743V3.355zm2.083 11.325h-2.083v-4.49h2.083c2.049 0 3.082.621 3.082 2.146 0 1.582-1.05 2.344-3.082 2.344zM23.533 0c-4.446 0-7.488 3.26-7.488 8.942 0 5.683 3.042 9.093 7.488 9.093 4.447 0 7.488-3.41 7.488-9.093C31.021 3.281 27.98 0 23.533 0zm0 14.64c-2.249 0-3.668-2.21-3.668-5.698 0-3.487 1.418-5.546 3.668-5.546 2.249 0 3.668 2.059 3.668 5.546 0 3.488-1.418 5.698-3.668 5.698z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 0,
    y: 0.054,
    width: 10.028,
    height: 7.974
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0.054,
    width: 10.028,
    height: 7.974,
    id: "bj6fr9d4sb_5_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "iv3z3d8tta_5_",
    className: "st2",
    d: "M-.001 18.035h111.768V0H-.001v18.035z"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M10.028 8.028H0S-.234-1.662 10.028.322v7.706z"
  })), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_1_",
    filterUnits: "userSpaceOnUse",
    x: 7.714,
    y: 1.992,
    width: 4.39,
    height: 4.396
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 7.714,
    y: 1.992,
    width: 4.39,
    height: 4.396,
    id: "bj6fr9d4sb_6_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "iv3z3d8tta_6_",
    className: "st2",
    d: "M-.001 18.035h111.768V0H-.001v18.035z"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M12.104 4.19a2.196 2.196 0 0 1-4.39 0 2.196 2.196 0 1 1 4.39 0"
  })), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_2_",
    filterUnits: "userSpaceOnUse",
    x: 8.761,
    y: 3.115,
    width: 2.175,
    height: 2.18
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 8.761,
    y: 3.115,
    width: 2.175,
    height: 2.18,
    id: "bj6fr9d4sb_7_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "iv3z3d8tta_7_",
    className: "st2",
    d: "M-.001 18.035h111.768V0H-.001v18.035z"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M10.936 4.205a1.089 1.089 0 1 1-2.175 0 1.089 1.089 0 0 1 2.175 0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobLogo);
export default __webpack_public_path__ + "static/media/job-logo.da3e376b2d8aa2e06ad6b49b8f171cb5.svg";
export { ForwardRef as ReactComponent };